import React from 'react';

import { t } from '../../../../../../modules/infra/i18n';

const NoMatches = () => (
  <div className="vendor-matches-table__tbody vendor-matches-table__spin">
    {t('products:shopify.no_matches_found')}
  </div>
);

export default NoMatches;
